<script lang="ts">
    import { reviewsApplicationLoggerToken } from "@apps/reviews/tokens";
    import QuestionsListWidget from "@apps/reviews/widgets/questions_list_widget/QuestionsListWidget";
    import { ProductIdFromStaticProvider } from "@lib/ProductIdManager/ProductIdFromStaticProvider";
    import { ProductIdManager } from "@lib/ProductIdManager/ProductIdManager";
    import { container } from "tsyringe";

    import Widget from "@components/Widget.svelte";

    export let productId: number;

    const productIdManager = new ProductIdManager();
    let productIdFromStaticProvider: ProductIdFromStaticProvider;

    const updateProductId = (productId: number) => {
        if (productIdFromStaticProvider) {
            productIdManager.unregisterProvider(productIdFromStaticProvider);
        }
        productIdFromStaticProvider = new ProductIdFromStaticProvider(
            productId
        );
        productIdManager.registerProvider(productIdFromStaticProvider);
    };
    $: {
        updateProductId(productId);
    }
</script>

<Widget
    widget={QuestionsListWidget}
    params={[
        {
            isWidgetShadowRootEnabled: false,
            productIdManager,
            showAddQuestionButton: false,
            showAddQuestionButtonInEmptyList: false,
        },
        container.resolve(reviewsApplicationLoggerToken),
    ]}
/>
